import { createFileRoute } from "@tanstack/react-router";
import ListJoinPage from "@/site/pages/list-join";

// A birthday list's join link (PRD 16 §6.1 "Preview" / "Join"). Public: the token IS the
// invitation. A signed-in member joins in one tap; anyone else fills in their birthday and goes
// through the ordinary sign-up (D2), and the join completes once the session lands.
export const Route = createFileRoute("/lists/$token")({
  component: ListJoinPage,
});
